import isEmpty from 'lodash-es/isEmpty';
import { ILocation } from 'wisestep-api';

export default function formatLocations(locations: ILocation[] | undefined) {
  let state = '';
  const locationsString: string[] = [];

  if (locations == undefined) {
    return [];
  } else {
    for (let i = 0; i < locations.length; i++) {
      if (
        isEmpty(locations[i].city) &&
        isEmpty(locations[i].state) &&
        isEmpty(locations[i].country)
      ) {
        locationsString.push(locations[i].continent);
      }
      if (locations[i]?.state?.length > 0) {
        if (locations[i].stateCode && locations[i].stateCode.length == 2) {
          state = locations[i].stateCode + ', ';
        } else {
          state = locations[i].state + ', ';
        }
      }
      locationsString.push(
        (locations[i].city?.length > 0 ? locations[i].city + ', ' : '') +
          state +
          locations[i].country
      );
    }
  }

  return locationsString;
}
